import { combineReducers } from 'redux'

// ACTIONS
export const FETCH_DETAIL = 'company/positionsDashboard/companies/FETCH_DETAIL'
export const FETCH_DETAIL_SUCCESS = 'company/positionsDashboard/companies/FETCH_DETAIL_SUCCESS'

export const RESET_DETAIL = 'company/positionsDashboard/companies/RESET_DETAIL'

export const TOGGLE_LOADING_DETAIL = 'company/positionsDashboard/companies/TOGGLE_LOADING_DETAIL'

// ACTION CREATORS
export const fetchDetail = companyId => ({
  type: FETCH_DETAIL,
  payload: { companyId },
})

export const fetchDetailSuccess = ({ result }) => ({
  type: FETCH_DETAIL_SUCCESS,
  payload: { ...result },
})

export const toggleLoadingDetail = loadingDetail => ({
  type: TOGGLE_LOADING_DETAIL,
  payload: { loadingDetail },
})

export const resetDetail = () => ({
  type: RESET_DETAIL,
})

// REDUCERS
const defaultMember = {
  interview_requests: [],
  placements: [],
}

const member = (state = defaultMember, { type, payload }) => {
  switch (type) {
    case FETCH_DETAIL_SUCCESS:
      return {
        ...state,
        ...payload,
      }

    case RESET_DETAIL:
      return defaultMember

    default:
      return state
  }
}

const defaultUtils = {
  loadingDetail: true,
}

const utils = (state = defaultUtils, { type, payload }) => {
  switch (type) {
    case TOGGLE_LOADING_DETAIL:
      return {
        ...state,
        ...payload,
      }

    case RESET_DETAIL:
      return defaultUtils

    default:
      return state
  }
}

export default combineReducers({
  member,
  utils,
})
